import {Button} from "../../../basic/button";
import {Input} from "../../../basic/input";
import {Label} from "../../../basic/label";
import {Plus} from "lucide-react";
import {toast} from "sonner";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface AddLicenseFormProps {
    newLicenseId: string;
    setNewLicenseId: (value: string) => void;
    onAddLicense: () => void;
    isLoading?: boolean;
}

export function AddLicenseForm({newLicenseId, setNewLicenseId, onAddLicense, isLoading = false}: AddLicenseFormProps) {
    const {t} = useTranslationWithKeys();

    const handleAddLicense = () => {
        if (!newLicenseId.trim()) {
            toast.error(t('admin.teams.teamManagement.errors.enterLicenseId'));
            return;
        }

        onAddLicense();
    };

    return (
        <div className="space-y-4 pt-4 border-t">
            <Label>{t('admin.teams.teamManagement.addLicense')}</Label>
            <div className="flex gap-2">
                <Input
                    placeholder={t('admin.teams.teamManagement.enterLicenseId')}
                    value={newLicenseId}
                    onChange={(e) => setNewLicenseId(e.target.value)}
                    className="flex-1"
                />
                <Button onClick={handleAddLicense} disabled={isLoading}>
                    <Plus className="h-4 w-4 mr-2"/>
                    {isLoading ? t('common.adding') : t('admin.teams.teamManagement.addLicenseButton')}
                </Button>
            </div>
            <p className="text-muted-foreground">
                {t('admin.teams.teamManagement.addLicenseDescription')}
            </p>
        </div>
    );
}